import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUserStore } from "../../../store/userStore.js";

import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";

import ProfileTab from "../../../components/tab/profiletab";
import Spacer from "../../../components/spacer/spacer";
import editProfileTabItems from "../../../utils/arrayitems/editprofileitems";

import BasicInfo from "./basicinfo";
import PhyscialLifestyle from "./physicallifestyle";
import FamilyDetails from "./familydetails";
import ReligiousStatus from "./religiousstatus";
import EducationCareer from "./educationcareer";
import PersonalityHobby from "./personalityhobby";
import ProfileDescription from "./profiledescription";

import "./styles.css";

const EditProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getUser } = useUserStore();

  const tabParam =
    new URLSearchParams(location.search).get("tab") ?? "basicInfo";
  const username = location.pathname.split("/")[2];

  const [activeTab, setActiveTab] = useState(tabParam);

  useEffect(() => {
    getUser({ username });
  }, [getUser, username]);

  useEffect(() => {
    setActiveTab(tabParam);
  }, [tabParam]);

  const handleTab = (name) => {
    setActiveTab(name);
    navigate(`/userprofileoverview/${username}/editUserProfile?tab=${name}`);
  };

  return (
    <UserProfileLayout>
      <div className="edit-profile-container">
        <ProfileTab
          tabItems={editProfileTabItems}
          handleTab={handleTab}
          activeTab={activeTab}
        />

        <Spacer height="32px" />
        <div className="edit-profile-content-container">
          {activeTab === "physicalLifestyle" ? (
            <PhyscialLifestyle handleTab={handleTab} />
          ) : activeTab === "familyDetails" ? (
            <FamilyDetails handleTab={handleTab} />
          ) : activeTab === "religiousStatus" ? (
            <ReligiousStatus handleTab={handleTab} />
          ) : activeTab === "educationCareer" ? (
            <EducationCareer handleTab={handleTab} />
          ) : activeTab === "personalityHobbies" ? (
            <PersonalityHobby handleTab={handleTab} />
          ) : activeTab === "profileDesc" ? (
            <ProfileDescription handleTab={handleTab} />
          ) : (
            <BasicInfo handleTab={handleTab} />
          )}
        </div>
        <Spacer height="32px" />
      </div>
    </UserProfileLayout>
  );
};

export default EditProfile;
